import { ModalSize } from '../../content/ItemType';

/**
 * Represents the most general model for properties that are related only to the UI and server does not use.
 * Data in the model are persisted 'as is' by the server-side thus client-side is fully responsible for the data contract not to break.
 * Model might be extended without any need of the server-side modification.
 */
export type PropertiesServerModel = Record<string, unknown>;

export const DEFAULT_MODAL_SIZE = ModalSize.Fullscreen;
